import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/landing/Navbar";
import { PricingSection } from "@/components/landing/PricingSection";
import { FooterSection } from "@/components/landing/FooterSection";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export default function Pricing() {
  const { user } = useAuth();
  const hasTracked = useRef(false);

  // Track pricing page visit for retargeting
  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;

    const trackVisit = async () => {
      const email = user?.email;
      if (!email) return;

      try {
        await supabase.from("retargeting_events" as any).insert({
          email,
          user_id: user.id,
          event_type: "pricing_page_visit",
          metadata: { first_name: user.user_metadata?.display_name || user.user_metadata?.name || "Creator" },
        } as any);
      } catch (err) {
        console.warn("Pricing page tracking error:", err);
      }
    };

    trackVisit();
  }, [user]);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Pricing & Plans | AI StoryCraft Studio</title>
        <meta
          name="description"
          content="Compare AI StoryCraft Studio plans with a 7-day free trial, monthly and annual pricing, and credits for every AI tool."
        />
        <link rel="canonical" href="https://ai-storycraft-studio.com/pricing" />
        <meta property="og:title" content="Pricing & Plans | AI StoryCraft Studio" />
        <meta
          property="og:description"
          content="Compare AI StoryCraft Studio plans with a 7-day free trial, monthly and annual pricing, and credits for every AI tool."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ai-storycraft-studio.com/pricing" />
        <meta property="og:image" content="https://ai-storycraft-studio.com/mockups/mockup-nexis-ai.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pricing & Plans | AI StoryCraft Studio" />
        <meta
          name="twitter:description"
          content="Compare AI StoryCraft Studio plans with a 7-day free trial, monthly and annual pricing, and credits for every AI tool."
        />
        <meta name="twitter:image" content="https://ai-storycraft-studio.com/mockups/mockup-nexis-ai.png" />
      </Helmet>
      <Navbar />
      <main className="pt-8">
        <PricingSection />
      </main>
      <FooterSection />
    </div>
  );
}
